module.exports = __webpack_public_path__ + "static/media/Archive Blue.8fecf8fd.svg";